/* eslint-disable no-use-before-define */
/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable no-plusplus */
/* eslint-disable prefer-const */
import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { streamStyle } from './streamSummary_style';
import { RationValWidth, ArialRegural, ArialB600, getFloatVal, ChineseFonts } from '../../fonts/font';
// import MembraneSeparator from '../membrane-separator/desalination';
// import FSDBalance from '../flow-balance/fsdBalance';

// let tablewidth = 100;
const radius = 5;
// let tableCount = 0;
let tempval = true;

const StreamSummary = (props) => {
  const { stream_output, unit_set_dict, serialNum, langualgeCheck, translateObject } = props;
  let { subSerialNum } = props;
  // const [rowCount] = useState(6);
  // const [headerParameterWidth] = useState(2);
  // tablewidth = tableWidth;
  const items = Object.keys(stream_output);
  const getUnitValue = (item) => {
    if (item === 'Pressure') {
      return `${unit_set_dict.Pressure}` || 'atm';
    } if (item === 'Flow') {
      return `${unit_set_dict['Volume Flow']}` || 'gpm';
    } return '';
  };

  const getAllKeyValue = () => {
    const data = [];
    items.map((ele) => {
      if (stream_output[ele]) {
        const { sat_indices, prop_dict } = stream_output[ele];
        const allVal = {
          streamid: ele,
          label: stream_output[ele].label ? stream_output[ele].label : '-',
          flow: prop_dict.flow,
          temp: prop_dict.temp,
          press: prop_dict.press,
          tds: prop_dict.tds,
          malk: prop_dict.malk,
          hardness: stream_output[ele].hardness,
          ph: prop_dict.ph,
          conductivity: sat_indices.conductivity
        };
        if (tempval) {
          delete allVal.temp;
        } else {
          delete allVal.malk;
        }
        return data.push(allVal);
      }
    });
    return data;
  };
  const createContent = () => {
    const headerData = getAllKeyValue();
    const data = Object.values(stream_output);
    // const parameter = headerData;
    return (
      data.map((ele, index) => {
        return (
          <View key={index}
            style={[
              streamStyle.tableRow1, { width: '100%' },
            ]}
          >
            {Object.keys(headerData[index]).map((childEle, childInd) => {
              return (
                <View key={childInd}
                  style={[
                    streamStyle.tableCol1, { width: '100%', borderTop: 0, },
                    childInd === 1 && { width: '200%' },
                    childInd > 0 && { borderLeft: 0 },
                    (index === data.length - 1 && childInd === 0) && { borderBottomLeftRadius: radius, borderBottomColor: '#002D62' },
                    (index === data.length - 1 && childInd === Object.keys(headerData[index]).length - 1) && { borderBottomRightRadius: radius, borderRightColor: '#002D62', borderBottomColor: '#002D62' },
                    (index === data.length - 1) && { borderBottomColor: '#002D62' },
                    (childInd === Object.keys(headerData[index]).length - 1) && { borderRightColor: '#002D62' }
                  ]}
                >
                  <Text style={[streamStyle.tableCell, streamStyle.firstChild, { fontFamily: ArialRegural }, langualgeCheck ? { fontFamily: ChineseFonts } : {}]}>
                    {childInd === 0 ? headerData[index][childEle] : getFloatVal(headerData[index][childEle])}
                  </Text>
                </View>
              );
            })
            }
          </View>
        );
      })
    );
  };
  const createHeader = (headerData) => {
    return (
      <View fixed>
        <View
          style={[
            streamStyle.tableRow, { width: '100%' },
          ]}>
          {headerData.map((ele, ind) => {
            return (
              <View key={ind}
                style={[
                  streamStyle.tableCol, { width: '100%' },
                  ind === 1 && { width: '200%' },
                  ind === 0 && { borderTopLeftRadius: radius },
                  ind > 0 && { borderLeft: 0 },
                  ind === headerData.length - 1 && { borderTopRightRadius: radius, borderRightColor: '#002D62' }
                ]}
              >
                <Text
                  style={[
                    streamStyle.tableCell, { fontFamily: ArialB600 },
                    ind === 0 && streamStyle.firstChild,
                    ind > 0 && streamStyle.restChild,
                    langualgeCheck ? { fontFamily: ChineseFonts } : {}
                  ]}>
                  {(() => {
                    let text = ele;
                    const parts = text.split(',');
                    parts[0] = translateObject(parts[0].trim());
                    text = parts.join(',');
                    return text;
                  })()}
                </Text>
              </View>
            );
          })}
        </View>
      </View>
    );
  };
  const createTable = () => {
    const { temp } = stream_output[items[0]];
    Object.values(stream_output).forEach(ele => {
      if (ele && Number(ele.temp).toFixed(2) !== Number(temp).toFixed(2)) {
        tempval = false;
      }
    });
    let spalitArray = [[
      'Stream Id',
      'Stream Name',
      `Flow, ${getUnitValue('Flow')}`,
      `Temperature, ${unit_set_dict.Temperature}`,
      `Pressure, ${getUnitValue('Pressure')}`,
      'TDS, mg/l',
      'Alkalinity, ppm CaCO3',
      'Hardness, ppm as CaCO3',
      'pH',
      'Conductivity at 25°C, µS/cm '
    ]];
    if (tempval) {
      spalitArray[0].splice(3, 1);
    } else {
      spalitArray[0].splice(6, 1);
    }
    const finalTable = spalitArray.map((ele, ind) => {
      return (
        <View key={ind} style={{ marginTop: 10 }}>
          {createHeader(ele)}
          {createContent(ele)}
        </View>
      );
    });
    return finalTable;
  };
  return (
    // break keywork remove and add wrap keyword because big flowsheet like (UPW `PFD_WQ_permeate_EDI_Rev3_productspecified.win`)
    // Stream Property Summary (section 1.2) data is overflowing and thus report was not getting generated.
    <View wrap style={{ width: '100%', flexDirection: 'column', marginBottom: RationValWidth(32) }}>
      <View style={[streamStyle.textHeader, { marginTop: 15 }]} bookmark={{ title: `${serialNum}.${subSerialNum} Stream Property Summary` }}>
        <Text style={{ paddingLeft: 0, ...(langualgeCheck && { fontFamily: ChineseFonts }) }}>{serialNum}.{subSerialNum++}</Text>
        <Text style={{ paddingLeft: 5, ...(langualgeCheck && { fontFamily: ChineseFonts }) }}>{translateObject('Stream Property Summary')}</Text>
      </View>
      {createTable(items, stream_output)}
      {/* {false && invoice.coverpage_dict && Object.keys(invoice.coverpage_dict).length && invoice.coverpage_dict.flow_bal && Object.keys(invoice.coverpage_dict.flow_bal).length && (
        <View
          style={[
            { marginTop: '15', width: '100%' }
          ]}
          bookmark={{ title: `${serialNum}.${subSerialNum} FSD Flow Balance` }} >
          <FSDBalance
            pageWidth={1140}
            tableWidth={1140}
            items={invoice.coverpage_dict.flow_bal}
            serialNum={serialNum}
            subSerialNum={subSerialNum++}
          />
        </View>
      )}
      {false && invoice.coverpage_dict.flow_summary && Object.keys(invoice.coverpage_dict).length && Object.keys(invoice.coverpage_dict.flow_summary).length && (
        <View break
          style={[
            { marginTop: '15', width: '100%' }
          ]}
          bookmark={{ expanded: true, title: `${serialNum}.${subSerialNum} Desalination \\ Demineralization \\ Membrane Separator (MEMS) Unit-Level Flow Summary` }}>
          <MembraneSeparator
            pageWidth={1140}
            system_units={invoice.system_units}
            items1={invoice.coverpage_dict.flow_summary}
            tableWidth={1140}
            serialNum={serialNum}
            subSerialNum={subSerialNum++}
          />
        </View>
      )} */}
    </View>
  );
};

export default StreamSummary;